import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskService } from "./task.services";
import { TASK_KEYS } from "./task.keys";

export const useCreateTask = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: taskService.createTask,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: TASK_KEYS.GET_TASKS({}),
      });
    },
  });
};

export const useUpdateTask = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: taskService.updateTask,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: TASK_KEYS.GET_TASKS({}),
      });
    },
  });
};

export const useCreateNote = () => {
  return useMutation({
    mutationFn: taskService.createNote,
  });
};

export const useDeleteTask = () => {
  return useMutation({
    mutationFn: taskService.deleteTask,
  });
};
